import React from 'react';

interface FotoUploadProps {
  foto: string;
  nome: string;
  onChange: (foto: string) => void;
}

const FotoUpload: React.FC<FotoUploadProps> = ({ foto, nome, onChange }) => {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        onChange(event.target?.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="flex flex-col items-center space-y-4">
      <div className="relative">
        {foto ? (
          <img
            src={foto}
            alt="Foto do colaborador"
            className="w-24 h-24 rounded-full object-cover border-4 border-gray-200"
          />
        ) : (
          <div className="w-24 h-24 rounded-full bg-gray-200 flex items-center justify-center border-4 border-gray-200">
            <span className="text-2xl font-bold text-gray-500">
              {nome ? nome.charAt(0).toUpperCase() : '?'}
            </span>
          </div>
        )}
        <label className="absolute bottom-0 right-0 bg-blue-500 text-white p-2 rounded-full cursor-pointer hover:bg-blue-600 transition-colors">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          <input
            type="file"
            accept="image/*"
            className="hidden"
            onChange={handleFileChange}
          />
        </label>
        {foto && (
          <button
            type="button"
            onClick={() => onChange('')}
            className="absolute bottom-0 left-0 bg-red-500 text-white p-2 rounded-full cursor-pointer hover:bg-red-600 transition-colors"
            title="Remover foto"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
      <div className="text-center">
        <p className="text-sm text-gray-600">Foto do Colaborador</p>
        <p className="text-xs text-gray-400">
          {foto ? 'Clique no + para alterar ou X para remover' : 'Clique no ícone + para adicionar'}
        </p>
      </div>
    </div>
  );
};

export default FotoUpload;
